import Vue from 'vue'
import vueSkeletonLoading from 'vue-skeleton-loading'

Vue.use(vueSkeletonLoading)
